import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../core/services/common.service';
import { Loader } from '../../../../shared/components/loader/loader';
import { CustomPaginationComponent } from '../../../../shared/components/custom-pagination/custom-pagination.component';
import { ttd_endpoint } from '../../../data/api-endpoint/ttd-endpoint';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import { Subscription } from 'rxjs';
import { UpperCasePipe } from '../../../../shared/pipes/upper-case-pipe';
import { NumberSuffixPipe } from '../../../../shared/pipes/number-suffix-pipe';
@Component({
  selector: 'app-content-pool-listing',
  imports: [CommonModule, Loader, CustomPaginationComponent,
    FormsModule, NoDataComponent,UpperCasePipe ,NumberSuffixPipe],
  templateUrl: './content-pool-listing.html',
  styleUrl: './content-pool-listing.scss'
})
export class ContentPoolListing { 
  sortingKey: string = '';
  sortingValue: string = '';
  searchIcon = 'assets/img/search.svg';
  filterIcon = 'assets/img/filter.png';
  plusIcon = 'assets/img/plus.svg';
  editIcon = 'assets/img/edit.png';
  deleteIcon = 'assets/img/bin.png';
  upIcon = 'assets/img/up.png';
  downIcon = 'assets/img/down.png';
  poolId!: string


  currentItem: any = null;

  debounceTimeout: any

  loading: boolean = false;
  isActiveFilter: boolean = false;
  toggleFilter: boolean = false;
  noData: boolean = false;
  totalCount: number = 0;
  isAdmin:boolean = false;


  filter: any = {
    page: 1,
    limit: 10,
    search: '',
    category: [],
    publisher: [],
    sortKey: '',
    sortValue: ''
  }

  modalConfig: { isOpen: boolean, type: 'delete' | 'deactivate' | 'activate', contentName?: string } = {
    isOpen: false,
    type: 'delete'
  };


  publisherList: any = [] ;
  CategoryList: any = [];

  contentPoolList: any[] = []
  userPermissions: any[] = [];
  activeDropdownIndex: number = -1;

  userSubscription: Subscription = new Subscription();



  constructor(private _router: Router, private _commonService: CommonService,
    private _contentMapper: ContentMapperService, private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this.fetchCustomCategory();
    this.fetchContentPoolList('ngOnInit');

    this.userSubscription = this._commonService.getUserDetail().subscribe((user: any) => {
      this.isAdmin = user.role === 'admin';
      this.userPermissions = user.permissions_ids;
    });

    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.action-dropdown')) {
        this.activeDropdownIndex = -1;
      }
    });

  }

 



  openFilter() {
    this.toggleFilter = !this.toggleFilter;
  }

  navigateToCreateContentPool() {
    this._router.navigate(['/content-pool/create-content-pool'])
  }

  navigateToEditContentPool(id: number) {
    this._router.navigate(['/content-pool/edit-content-pool', id])
  }

  checkIsErrorMessageValid(error: any) {
    if(typeof error?.error?.message === 'string') {
      return error?.error?.message;
    }
    return 'An unknow error occured';
  }




  sorting(key: string) {
    this.sortingKey = key;
    this.sortingValue = !this.sortingValue ? 'ASC' : (this.sortingValue === 'ASC' ? 'DESC' : 'ASC');
    this.filter.sortKey = this.sortingKey;
    this.filter.sortValue = this.sortingValue;
    this.filter.page = 1;
    this.fetchContentPoolList()
  }


  clearFilter() {
    this.filter = {
      page: 1,
      limit: 10,
      search: '',
      category: [],
      publisher: [],
      sortKey: '',
      sortValue: ''
    };
    this.sortingKey = ''
    this.sortingValue = ''
    this.fetchContentPoolList()

  }

  onSearch(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.filter.search = value?.trim();
      this.filter.page = 1;
      this.fetchContentPoolList()
    }, 1000);
  }



  clearFilterDropdown(type: string) {
    const action: Record<string, () => void> = {
      'category': () => this.filter.category = [],
      'publisher': () => this.filter.publisher = [],
    };
    action[type]()
    this.filter.page = 1;
    this.fetchContentPoolList();

  }


  selectFilterDrowDownItem(data: { checked: boolean }, type: string) {
    const { checked } = data;
    const action: Record<string, () => void> = {
      'category': () => this.filter = {
        ...this.filter,
        category: checked ? this.CategoryList : []
      },
      'publisher': () => this.filter = {
        ...this.filter,
        publisher: checked ? structuredClone(this.publisherList) : []
      },
    };
    action[type]();
    this.filter.page = 1;
    this.fetchContentPoolList();

  }

  isItemChecked(data: { checked: boolean, item: any }, type: string) {
    const { checked, item } = data;
    const action: Record<string, () => void> = {
      'category': () => checked ? this.filter.category.push(item) : this.filter.category = this.filter.category.filter((child: any) => child.name != item.name),
      'publisher': () => checked ? this.filter.publisher.push(item) : this.filter.publisher = this.filter.publisher.filter((child: any) => child.name != item.name),
    };
    action[type]();
    this.filter.page = 1;
    this.fetchContentPoolList();

  }

  fetchUserDataByPage(data: { page: number }) {
    this.filter.page = data.page;
    this.fetchContentPoolList();
  }


  openDeleteModal(contentPool: any): void {
    this.currentItem = contentPool;
    this.modalConfig = {
      isOpen: true,
      type: 'delete',
      contentName: contentPool.contentName
    };
  }

  openStatusChangeModal(contentPool: any, isActivating: boolean): void {
    this.currentItem = contentPool;
    this.modalConfig = {
      isOpen: true,
      type: isActivating ? 'activate' : 'deactivate',
      contentName: contentPool.contentName
    };
  }

 

  onModalCancel(): void {
    this.closeModal();
    if (this.poolId) {
      const poolName = this.contentPoolList.find((pool) => pool.id == this.poolId);
      if (poolName) {
        delete poolName.tempStatus;
        this.poolId = '';
      }
    }
  }

  onToggleStatus(contentPool: any, event: any): void {
    event.preventDefault();
    this.poolId = contentPool.id
    if (contentPool.status == 'active') {
      contentPool.tempStatus = false
      this.openStatusChangeModal(contentPool, false);
    } else {
      contentPool.tempStatus = true;
      this.openStatusChangeModal(contentPool, true);
    }
  }

  toggleDropdown(index: number): void {
    this.activeDropdownIndex = this.activeDropdownIndex === index ? -1 : index;
    
  }

  togglePoolStatus(pool: any): void {
    this.activeDropdownIndex = -1;
    if (pool.status === 'active') {
      pool.tempStatus = false;
      this.openStatusChangeModal(pool, false);
    } else {
      pool.tempStatus = true;
      this.openStatusChangeModal(pool, true);
    }
  }

  reviewContentPool(poolId: number): void {
    this.activeDropdownIndex = -1;
    this._router.navigate(['/content-pool/review', poolId]);
  }

  private closeModal(): void {
    this.modalConfig.isOpen = false;
    this.currentItem = null;
  }

 
  private fetchCustomCategory() {
    this._contentMapper.get(ttd_endpoint.custom_categories).subscribe({
      next: (response: any) => {
        this.CategoryList = response.result;
      }, error: (error) => {
        this.CategoryList = []
        console.error('Error occured while fetching category', error.message);
      }
    })
  }


  private fetchContentPoolList(source: string = 'unknown') {
    this.loading = true;
    this._contentMapper.post(ttd_endpoint.contentList,this.filter).subscribe({
      next: (response: any) => {
        const {contents= [],totalCount = 0} = response.results
        this.totalCount = +totalCount;
        this._commonService.updateSharedData(+totalCount);
        this.contentPoolList =contents || [];
        this.noData = source === 'ngOnInit' && this.contentPoolList.length === 0 ? true : false;
        this.loading = false
      }, error: (error) => {
        this.loading = false
        if (error.error.status_code !== 401 && error.error.status_code !== 403) {
          this.toastr.error(this.checkIsErrorMessageValid(error));
          console.error("Error occured while fetching content pool list", error.message);
        }
      }
    })

  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }


  getStatusChipClass(status: string): string {
    const statusTypeMap: Record<string, string> = {
      'active': 'active',
      'inactive': 'inactive'
    };
    
    return statusTypeMap[status?.toLowerCase()] || 'inactive';
  }

  handleContentPoolClick(_event: MouseEvent, poolId: string) {
    const selection = window.getSelection();
    if (selection && selection.toString().length === 0) {
      this._router.navigate(['/content-pool/edit-content-pool', poolId])
    }
  }
}
